import React from 'react';

import Thumb from '../img/personal-website.png';
import Img from '../img/personal-website2.png';

const PersonalWebsite = {
    id: 52, permalink: "personal-website", thumb: Thumb, title: "Personal Website", category: "Web Template", categoryURL: "webtemplate", detailImg1: Thumb, detailImg2: Img, previewTxt: "Preview", previewURL: "https://wasek23.github.io/personal-website/", sourceTxt: "", sourceURL: "", description: <>
        <h3>Personal Website is a Simple Portfolio Web Template.</h3>
        <p>&nbsp;</p>

        <h5>Main Featured:</h5>
        <ul>
            <li>Google Web Fonts Included.</li>
            <li>Fully Responsive Web Template.</li>
            <li>Custom CSS Animation.</li>
            <li>Linear Gradient Heading and Skew on hover.</li>
        </ul>

        <h5>Technology Used:</h5>
        <ul>
            <li>HTML5, CSS3, Sass, JavaScript.</li>
        </ul>
    </>
};

export default PersonalWebsite;